import cellFactory from './cell';
import size, { SIZE } from '../props/size';
import { getMaxWeight } from '../../util';

/**
 * Фабрика елемента row-element
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-table-block.json
 * @param  {Object} element
 * @return {Object}
 */
export default (function (element) {
    if (!element) {
        return null;
    }

    var cells = (element.cells || []).map(cellFactory);

    if (!cells.length) {
        return null;
    }

    return {
        cells: cells,
        topPadding: size(element.top_padding, SIZE.zero),
        bottomPadding: size(element.bottom_padding, SIZE.xxs),
        type: element.type,
        weight: getMaxWeight(cells)
    };
});